<template>
  <div>
    <div
      role="dialog"
      class="offcanvas offcanvas-top"
      tabindex="-1"
      ref="offcanvasEl"
      :id="$props.idFilters"
      :aria-labelledby="`${$props.idFilters}-titulo`"
      style="height: 75vh"
    >
      <div class="offcanvas-header">
        <!-- O id do título é derivado do id do painel: `offcanvasTopLabel` era fixo, e
             duas grades na mesma tela geravam dois elementos com o MESMO id — HTML
             inválido, e os dois painéis passavam a apontar para o primeiro título. -->
        <h4 :id="`${$props.idFilters}-titulo`">Filtros</h4>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Fechar filtros"
          title="Fechar filtros"
          ref="closeFilter"
        ></button>
      </div>
      <div class="offcanvas-body">
        <div class="row">
          <div
            class="mb-3 col-sm-6 col-lg-6 col-lg-6"
            v-for="column in filterableColumns"
            :key="column.datafield"
          >
            <label
              :for="column.datafield"
              v-if="column.filtertype != 'checkbox'"
              class="form-label"
            >
              {{ column.text }}
            </label>

            <div class="row">
              <div class="col-md-3">
                <DropDownConsulte
                  :id="'selectFilterExpression' + column.datafield"
                  :aria-label="`Tipo de comparação para ${column.text}`"
                  v-model="filterExpressionAux[column.datafield]"
                  :disabled="
                    column.filtertype == 'autocomplete' ||
                    column.filtertype == 'merTipoMaterial' ||
                    column.filtertype == 'gesFornecedor' ||
                    column.filtertype == 'gesEscola' ||
                    column.filtertype == 'pcoProjeto' ||
                    column.filtertype == 'list' ||
                    column.filtertype == 'urlList' ||
                    column.filtertype == 'checkbox' ||
                    column.filtertype == 'radiobuttonlist'
                  "
                  :array="operadoresDisponiveis(column.filtertype)"
                  row-label="label"
                  row-value="value"
                  :placeholder="''"
                />
              </div>
              <div class="col">
                <input
                  v-if="
                    column.filtertype == 'text' ||
                    column.filtertype == 'number' ||
                    column.filtertype == 'date' ||
                    column.filtertype == 'text'
                  "
                  :type="column.filtertype"
                  v-model="filterAux[column.datafield]"
                  :id="column.datafield"
                  class="form-control"
                />

                <MultiSelect
                  v-if="column.filtertype == 'autocomplete' || column.filtertype == 'autoComplete'"
                  v-model="filterAux[column.datafield]"
                  :mode="column.filtermode ? column.filtermode : 'single'"
                  :searchable="true"
                  :options="filtersData[column.datafield] ?? []"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :trackBy="column.filtertextfield"
                  :valueProp="column.filtervaluefield"
                  :object="false"
                  :label="column.filtertextfield"
                  placeholder="Selecione um item."
                >
                </MultiSelect>

                <DropDownListMerTipoMaterial
                  v-if="column.filtertype == 'merTipoMaterial'"
                  :key="(dataSource as any)?.merClassificacaoId"
                  v-model="filterAux[column.datafield]"
                  :mer-classificacao-id="(dataSource as any)?.merClassificacaoId"
                />
                <DropDownListFornecedor
                  v-if="column.filtertype == 'gesFornecedor'"
                  v-model="filterAux[column.datafield]"
                />
                <DropDownListEscola
                  v-if="column.filtertype == 'gesEscola'"
                  v-model="filterAux[column.datafield]"
                />
                <DropDownListPcoProjeto
                  v-if="column.filtertype == 'pcoProjeto'"
                  :key="`pcoProjetoFiltro_${filterAux.gesEscolaId ?? 0}`"
                  v-model="filterAux[column.datafield]"
                  :ges-escola-id="obterGesEscolaIdFiltro() ?? 0"
                />

                <input
                  v-if="!column.filtertype"
                  type="text"
                  v-model="filterAux[column.datafield]"
                  :id="column.datafield"
                  class="form-control"
                />

                <div class="form-check" v-if="column.filtertype == 'checkbox'">
                  <label
                    :for="column.datafield"
                    v-if="column.filtertype == 'checkbox'"
                    class="form-check-label"
                    >{{ column.text }}</label
                  >
                  <input
                    type="checkbox"
                    v-model="filterAux[column.datafield]"
                    :id="column.datafield"
                    class="form-check-input"
                  />
                </div>

                <DropDownConsulte
                  v-if="column.filtertype == 'urlList' || column.filtertype == 'urlList'"
                  v-model="filterAux[column.datafield]"
                  :aria-label="`Filtrar por ${column.text}`"
                  :placeholder="''"
                >
                  <option value=""></option>
                  <option
                    :key="data[column.filtertextfield!]"
                    v-for="data in filtersData[column.datafield]"
                    :value="data[column.filtervaluefield!]"
                  >
                    {{ data[column.filtertextfield!] }}
                  </option>
                </DropDownConsulte>

                <DropDownConsulte
                  v-if="column.filtertype == 'list'"
                  v-model="filterAux[column.datafield]"
                  :aria-label="`Filtrar por ${column.text}`"
                  :placeholder="''"
                >
                  <option value=""></option>
                  <option
                    :key="column.filtertextfield ? data[column.filtertextfield] : data"
                    v-for="data in filtersData[column.datafield]"
                    :value="column.filtervaluefield ? data[column.filtervaluefield] : data"
                  >
                    {{ column.filtertextfield ? data[column.filtertextfield] : data }}
                  </option>
                </DropDownConsulte>

                <!-- `role="radiogroup"` + nome: sem isso o leitor de tela anuncia as
                     opções soltas ("Sim, botão de opção 1 de 2") sem dizer a que coluna
                     elas se referem. -->
                <div
                  v-if="column.filtertype == 'radiobuttonlist'"
                  class="d-flex flex-wrap gap-3"
                  role="radiogroup"
                  :aria-label="`Filtrar por ${column.text}`"
                >
                  <div
                    class="form-check"
                    v-for="data in filtersData[column.datafield]"
                    :key="column.filtervaluefield ? data[column.filtervaluefield] : data"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="`${column.datafield}_${column.filtervaluefield ? data[column.filtervaluefield] : data}`"
                      :name="`radioFilter_${column.datafield}`"
                      v-model="filterAux[column.datafield]"
                      :value="column.filtervaluefield ? data[column.filtervaluefield] : data"
                    />
                    <label
                      class="form-check-label"
                      :for="`${column.datafield}_${column.filtervaluefield ? data[column.filtervaluefield] : data}`"
                    >
                      {{ column.filtertextfield ? data[column.filtertextfield] : data }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-md-2">
              <!-- `example-select` era o id de exemplo do tema, repetido em cada grade
                   da tela; ids duplicados fazem o rótulo apontar sempre para o primeiro. -->
              <label :for="`${$props.idFilters}-registros-por-pagina`" class="form-label">
                Registros por Página
              </label>
              <DropDownConsulte
                :id="`${$props.idFilters}-registros-por-pagina`"
                v-model="rowsPerPage"
                :busca="false"
                :placeholder="''"
              >
                <option>5</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>35</option>
                <option>40</option>
                <option>45</option>
                <option>50</option>
                <option>55</option>
                <option>60</option>
                <option>65</option>
                <option>70</option>
                <option>75</option>
                <option>80</option>
                <option>85</option>
                <option>90</option>
                <option>95</option>
                <option>100</option>
              </DropDownConsulte>
            </div>
          </div>
        </div>
      </div>

      <div class="offcanvas-footer">
        <div class="d-flex justify-content-end">
          <button class="btn btn-outline-danger me-1" @click="clearFilters">Limpar</button>
          <button class="btn btn-primary" @click="filter">Filtrar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  /* eslint-disable vue/no-mutating-props */
  import DropDownListEscola from '@/components/formulario/gestao/DropDownListEscola.vue';
  import DropDownListFornecedor from '@/components/formulario/gestao/DropDownListFornecedor.vue';
  import DropDownListMerTipoMaterial from '@/components/formulario/merenda/DropDownListMerTipoMaterial.vue';
  import DropDownListPcoProjeto from '@/components/formulario/prestacaocontas/DropDownListPcoProjeto.vue';
  import { ConsulteGridColumnsModel, DataSource, FiltrosModel } from '@/datasources/consulte-grid';
  import { GridActionTypes } from '@/store/grid/action-types';
  import { focaveisDentro } from '@/uteis/dialogo-acessivel';
  import { AxiosResponse } from 'axios';
  import { defineComponent } from 'vue';
  import { mapActions } from 'vuex';

  // "Inicia com"/"Contém"/"Não Contém" são operações de texto -- não fazem sentido pra uma
  // coluna de data ou número (e "Contém" nem tem tradução em SQL pra DateTime/número, o
  // ApplyFilter do backend quebra se tentar). Cada filtertype só mostra os operadores que
  // fazem sentido pra ele.
  const OPERADORES_TEXTO = [
    { value: 'startswith', label: 'Inicia com' },
    { value: 'contains', label: 'Contém' },
    { value: 'notcontains', label: 'Não Contém' },
    { value: 'equals', label: 'Igual a' },
    { value: 'different', label: 'Diferente de' },
    { value: 'empty', label: 'Vazio' },
  ];
  const OPERADORES_NUMERICOS = [
    { value: 'equals', label: 'Igual a' },
    { value: 'greater_than_or_equal', label: 'Maior que ou igual' },
    { value: 'greater_than', label: 'Maior que' },
    { value: 'less_than_or_equal', label: 'Menor que ou igual' },
    { value: 'less_than', label: 'Menor que' },
    { value: 'different', label: 'Diferente de' },
    { value: 'empty', label: 'Vazio' },
  ];

  export default defineComponent({
    name: 'ConsulteGridFilters',
    components: {
      DropDownListMerTipoMaterial,
      DropDownListFornecedor,
      DropDownListEscola,
      DropDownListPcoProjeto,
    },

    async mounted() {
      // Ao ABRIR o painel, leva o foco para o primeiro campo útil (ver focarPrimeiroCampo).
      // Registrado ANTES do await: se `loadFilters` demorar ou lançar, o listener ainda existe.
      (this.$refs.offcanvasEl as HTMLElement | undefined)?.addEventListener(
        'shown.bs.offcanvas',
        this.focarPrimeiroCampo,
      );

      // Sincronizar rowsPerPage com o valor inicial do dataSource
      if (this.dataSource && this.dataSource.rowsPerPage) {
        this.rowsPerPage = this.dataSource.rowsPerPage;
      }
      await this.loadFilters();
      this.setDefaultFilterExpression();
    },

    beforeUnmount() {
      (this.$refs.offcanvasEl as HTMLElement | undefined)?.removeEventListener(
        'shown.bs.offcanvas',
        this.focarPrimeiroCampo,
      );
    },

    data() {
      return {
        rowsPerPage: 10,
        filterAux: {} as any,
        filterExpressionAux: {} as any,
        filtersData: {} as any,
        loading: true,
      };
    },
    computed: {
      filterableColumns() {
        return this.columns?.filter((x) => x.filterable);
      },
      flitersToDisplay(): any {
        let data = Object.assign(this.filterAux, {});

        Object.keys(data).forEach((x) => {
          if (!data[x]) delete data[x];
        });
        return data;
      },
    },
    methods: {
      ...mapActions([
        GridActionTypes.SET_FILTER,
        GridActionTypes.CLEAR_FILTERS,
        GridActionTypes.GET_GRID,
      ]),
      operadoresDisponiveis(filtertype: string | undefined) {
        return filtertype === 'date' || filtertype === 'number'
          ? OPERADORES_NUMERICOS
          : OPERADORES_TEXTO;
      },
      /*
       * Foco inicial do painel de filtros, no `shown.bs.offcanvas`. Leva o foco para o primeiro
       * controle útil (pulando o `.btn-close`), como o `abrirDialogo` faz nos modais.
       *
       * O FocusTrap do Bootstrap TRAVA o foco no contêiner do offcanvas por ~100ms após o
       * `shown` (autofocus): nesse intervalo `campo.focus()` é INERTE (medido ao vivo — só "pega"
       * a partir de ~150ms). Por isso reinsistimos a cada 50ms até o foco assentar num controle do
       * painel, ou desistimos após ~1s (aí fica no contêiner, que é um `role="dialog"` rotulado —
       * degradação aceitável). Enquanto a trava está ativa o focus() é no-op, então NÃO pisca.
       *
       * A GUARDA `painel.contains(ativo)` no topo garante que, se o foco JÁ está num controle do
       * painel — porque assentou OU porque o usuário clicou/tabulou num campo antes de a trava
       * soltar — a gente PARA e não rouba o foco de quem já entrou.
       */
      focarPrimeiroCampo() {
        const painel = this.$refs.offcanvasEl as HTMLElement | undefined;
        if (!painel) return;
        let tentativas = 0;
        const tentar = () => {
          const ativo = document.activeElement;
          if (ativo && ativo !== painel && painel.contains(ativo)) return;
          const uteis = focaveisDentro(painel);
          const primeiro = uteis.find((el) => !el.classList.contains('btn-close')) ?? uteis[0];
          if (!primeiro) return;
          primeiro.focus();
          tentativas += 1;
          if (tentativas < 20) window.setTimeout(tentar, 50);
        };
        tentar();
      },
      toJson(data: any) {
        return JSON.stringify(data);
      },
      filter() {
        this.dataSource?.clearFilters();
        Object.keys(this.filterAux).forEach((k) => {
          if (
            this.filterAux[k] === null ||
            this.filterAux[k] === undefined ||
            this.filterAux[k] === ''
          )
            return;

          if (Array.isArray(this.filterAux[k]) && this.filterAux[k].length == 0) return;

          let column = this.columns?.find((x) => x.datafield == k);
          if (
            column?.filtertype == 'merTipoMaterial' &&
            typeof (this.dataSource as any)?.setMerTipoMaterialId === 'function'
          ) {
            (this.dataSource as any).setMerTipoMaterialId(Number(this.filterAux[k]));
            return;
          }

          let currentFilter = new FiltrosModel(k, column!.conditionbetweenfilters ?? 'and');

          let filterExpression = this.filterExpressionAux[k] || 'contains'; // Valor padrão

          if (Array.isArray(this.filterAux[k])) {
            this.filterAux[k].forEach((x: any) => {
              currentFilter.addFilter(k, x, 'pt-Br', filterExpression, 'equals', 'k');
            });
          } else
            currentFilter.addFilter(
              k,
              this.filterAux[k].toString(),
              'pt-Br',
              filterExpression,
              'equals',
              'k',
            );

          // Usar método do dataSource para adicionar filtro ao invés de mutar diretamente
          if (this.dataSource && this.dataSource.filters) {
            this.dataSource.filters.push(currentFilter);
          }
        });

        // Aplicar filtros: ir para página 1 sempre
        if (this.dataSource) {
          this.applyFilterAndGoToPage1();
        }
        var elem = this.$refs.closeFilter;
        elem.click();
        //Comentei temporariamente, pois estava aplicando o filtro em todos os grids do sistema
        //this[GridActionTypes.SET_FILTER]({ grid: this.$route.name, filters: this.dataSource?.filters })
      },
      applyFilterAndGoToPage1() {
        // Resetar página para a primeira (0, igual à criação do dataSource) e chamar filter()
        if (this.dataSource) {
          this.dataSource.pageNumber = 0;
          if (typeof this.dataSource.filter === 'function') {
            this.dataSource.filter(this.rowsPerPage);
          }
        }
      },
      clearFilters() {
        this.dataSource?.clearFilters();
        if (typeof (this.dataSource as any)?.setMerTipoMaterialId === 'function') {
          (this.dataSource as any).setMerTipoMaterialId(null);
        }
        this.filterAux = {};

        // Resetar página para a primeira (0, igual à criação do dataSource) e recarregar
        if (this.dataSource) {
          this.dataSource.pageNumber = 0;
          if (typeof this.dataSource.filter === 'function') {
            this.dataSource.filter(this.rowsPerPage);
          }
        }

        var elem = this.$refs.closeFilter;
        elem.click();
        //this[GridActionTypes.CLEAR_FILTERS]({ grid: this.$route.name })
      },
      getDescriptionFilter(datafield: string): string {
        return this.filterableColumns?.find((x) => x.datafield == datafield)?.text ?? '';
      },
      getDescriptionFilterExpression(datafield: string): string {
        try {
          let x = document.getElementById(
            'selectFilterExpression' + datafield,
          ) as HTMLSelectElement;
          if (x) {
            let selectedText = x.options[x.selectedIndex].text;
            return selectedText;
          }
        } catch (error) {
          console.log(error);
        }
        return '';
      },
      setDefaultFilterExpression() {
        this.columns?.forEach((column) => {
          // Garantir que o valor do filtro para cada coluna seja "contains" por padrão
          if (!this.filterExpressionAux[column.datafield]) {
            if (
              column.filtertype == 'autocomplete' ||
              column.filtertype == 'merTipoMaterial' ||
              column.filtertype == 'gesFornecedor' ||
              column.filtertype == 'gesEscola' ||
              column.filtertype == 'pcoProjeto' ||
              column.filtertype == 'list' ||
              column.filtertype == 'urlList' ||
              column.filtertype == 'checkbox' ||
              column.filtertype == 'radiobuttonlist' ||
              // "contains" não existe pra DateTime/número -- o ApplyFilter do backend quebra
              // (Expression.Call procura um método Contains que não existe nesses tipos).
              column.filtertype == 'date' ||
              column.filtertype == 'number'
            )
              this.filterExpressionAux[column.datafield] = 'equals';
            else this.filterExpressionAux[column.datafield] = 'contains';
          }
        });
      },
      async loadFilters() {
        let gridState = await this[GridActionTypes.GET_GRID](this.$route.name);
        const filtrosAtivos =
          gridState && gridState.filters && gridState.filters.length > 0
            ? (gridState.filters as FiltrosModel[])
            : (this.dataSource!.filters as FiltrosModel[]);

        if (filtrosAtivos && filtrosAtivos.length > 0) {
          // Adicionar filtros ao datasource
          if (this.dataSource && this.dataSource.filters) {
            // Limpar e adicionar filtros
            this.dataSource.filters.length = 0;
            filtrosAtivos.forEach((f) => {
              if (this.dataSource && this.dataSource.filters) {
                this.dataSource.filters.push(f);
              }
            });
          }

          filtrosAtivos.forEach((x) => {
            const column = this.columns?.find((c) => c.datafield == x.field);

            x.filters.forEach((y) => {
              if (column?.filtermode == 'tags') {
                if (!this.filterAux[x.field]) this.filterAux[x.field] = [];

                this.filterAux[x.field].push(y.value);
              } else {
                if (column?.filtertype == 'checkbox')
                  this.filterAux[x.field] = y.value === true || y.value === 'true';
                else this.filterAux[x.field] = y.value;
              }
            });
          });
        }

        // Chamar load() que já se encarrega de setar loading
        if (this.dataSource && typeof this.dataSource.load === 'function') {
          this.dataSource.load();
        }

        let urlfiltersListUrl = this.filterableColumns?.filter(
          (x) =>
            x.filtertype &&
            ((x.filtertype as string).toLowerCase() == 'urllist' ||
              (x.filtertype as string).toLowerCase() == 'autocomplete'),
        );
        let urlfiltersList = this.filterableColumns?.filter(
          (x) =>
            x.filtertype &&
            ((x.filtertype as string).toLowerCase() == 'list' ||
              (x.filtertype as string).toLowerCase() == 'radiobuttonlist'),
        );

        urlfiltersListUrl?.forEach((x) => {
          if (x.filterlistpromise) {
            (x.filterlistpromise() as Promise<AxiosResponse>).then((dataAxios) => {
              if (Array.isArray(dataAxios.data)) this.filtersData[x.datafield] = dataAxios.data;
              else if (Array.isArray(dataAxios)) this.filtersData[x.datafield] = dataAxios;
            });
          }
        });

        urlfiltersList?.forEach((x) => {
          if (x.filterdata) {
            this.filtersData[x.datafield] = x.filterdata;
          }
        });
      },
      obterGesEscolaIdFiltro(): number | null {
        const gesEscolaId = Number(this.filterAux.gesEscolaId ?? 0);
        return Number.isNaN(gesEscolaId) || gesEscolaId <= 0 ? null : gesEscolaId;
      },
    },
    props: {
      columns: {
        type: Object as () => Array<ConsulteGridColumnsModel>,
      },

      dataSource: {
        type: Object as () => DataSource<any>,
      },
      idFilters: {
        type: String,
        required: true,
      },
    },
  });
</script>
<style lang="scss"></style>
